/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const EnumTypTreeNode = {
    TOPIC: 'TOPIC',
    CATALOGUE_ITEM: 'CATALOGUE_ITEM',
    LAYER: 'LAYER'
} as const;

export type EnumTypTreeNode = typeof EnumTypTreeNode[keyof typeof EnumTypTreeNode];



